import React, { useState, useEffect } from 'react';
import { useParams, Routes, Route } from 'react-router-dom';
import CompleteInterviewManagement from '../recruiter/CompleteInterviewManagement';
import CompanySettings from '../admin/CompanySettings';
import NotFoundPage from './NotFoundPage';
import ProtectedCompanyRoute from '../auth/ProtectedCompanyRoute';
import authService from '../../services/authService';

const AdminRouteWrapper: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const [isValidCompany, setIsValidCompany] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);
  const [companyName, setCompanyName] = useState<string>('');

  useEffect(() => {
    const validateCompany = async () => {
      if (!companyId) {
        setIsValidCompany(false);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        // テナント情報取得APIで企業の存在確認（認証不要の公開エンドポイント）
        const tenantResult = await authService.setupTenantByCompanyId(companyId);

        if (tenantResult.success) {
          setIsValidCompany(true);
          if (tenantResult.companyName) {
            setCompanyName(tenantResult.companyName);
          }
          console.log('✅ Valid company access:', companyId, tenantResult.companyName);
        } else {
          console.warn('Company not found:', companyId);
          setIsValidCompany(false);
        }
      } catch (error) {
        console.error('Company validation error:', error);
        setIsValidCompany(false);
      } finally {
        setLoading(false);
      }
    };

    validateCompany();
  }, [companyId]);

  // ローディング中
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative">
            <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto"></div>
          </div>
          <div className="mt-4">
            <h3 className="text-lg font-medium text-gray-900 mb-2">企業情報を確認中...</h3>
            <p className="text-sm text-gray-500">企業ID: {companyId}</p>
          </div>
        </div>
      </div>
    );
  }

  // 企業IDが無効または存在しない場合
  if (!isValidCompany || !companyId) {
    return <NotFoundPage type="admin" companyId={companyId} />;
  }

  // 有効な企業IDの場合、認証保護された管理画面を表示
  return (
    <ProtectedCompanyRoute>
      <Routes>
        <Route
          path="/"
          element={<CompleteInterviewManagement companyId={companyId} companyName={companyName} />}
        />
        <Route
          path="/settings"
          element={<CompanySettings companyId={companyId} companyName={companyName} />}
        />
      </Routes>
    </ProtectedCompanyRoute>
  );
};

export default AdminRouteWrapper;
